export function stripHtmlCode(html: string): string {
  return html.length === 0
    ? ''
    : html.replace(/<[^>]+>([^<]+)?/gm, '$1').trim();
}

export const webViewQueryParam = 'cetat=playbytr';

export const placementType = 'loyalty';
